import { Modal, Result, Button } from 'antd';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { primaryShades } from '../../../theme/theme';

const ConfirmRepublishCatalogModal = ({
    isOpen,
    onClose,
    onConfirm,
    catalogName
}) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
        >
            <Result
                icon={<PublishedWithChangesIcon style={{ color: primaryShades.primary300, fontSize: 64 }} />}
                title="Republish Catalog"
                subTitle={`Are you sure you want to republish the catalog "${catalogName || 'Untitled'}"? This will make it available to users again and a notification will be sent to confirm the republication.`}
                extra={[
                    <Button
                        key="republish"
                        type="primary"
                        onClick={onConfirm}
                    >
                        Republish
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmRepublishCatalogModal;
